"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.ConnectToCloud = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/styles");
var _pittaModules = require("@thingsw/pitta-modules");
var _ = require("..");
var _clsx = _interopRequireDefault(require("clsx"));
var _core = require("@material-ui/core");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var Webviewer = {
  mobile: 760
};
var useStyle = (0, _styles.makeStyles)(function (theme) {
  return {
    body: _defineProperty({
      display: "flex",
      flexDirection: "column",
      padding: 0,
      marginLeft: "auto",
      marginRight: "auto"
    }, theme.breakpoints.up(Webviewer.mobile), {
      width: 512,
      marginTop: theme.spacing(16.25),
      marginBottom: theme.spacing(16.25),
      padding: 0
    }),
    textTitle: _defineProperty({
      marginBottom: theme.spacing(4.125)
    }, theme.breakpoints.up(Webviewer.mobile), {
      marginBottom: 33
    }),
    appAnchor: _defineProperty({}, theme.breakpoints.up(Webviewer.mobile), {
      display: "flex",
      marginTop: 4
    }),
    compareCheckDiv: _defineProperty({
      marginBottom: 44,
      marginTop: theme.spacing(2.5),
      display: "flex",
      justifyContent: "center"
    }, theme.breakpoints.up(Webviewer.mobile), {
      marginBottom: theme.spacing(6),
      marginTop: theme.spacing(0)
    }),
    appStoreDiv: _defineProperty({}, theme.breakpoints.up(Webviewer.mobile), {
      display: "flex",
      marginBottom: 52
    }),
    qrCodeDiv: _defineProperty({}, theme.breakpoints.up(Webviewer.mobile), {
      marginTop: 23,
      display: "flex",
      justifyContent: "center"
    }),
    androidDiv: _defineProperty({
      paddingLeft: 0,
      paddingRight: theme.spacing(3.75)
    }, theme.breakpoints.up(Webviewer.mobile), {
      paddingLeft: theme.spacing(4),
      paddingRight: 0
    }),
    appsDiv: _defineProperty({
      paddingRight: theme.spacing(3)
    }, theme.breakpoints.up(Webviewer.mobile), {
      paddingRight: theme.spacing(4)
    }),
    cloudImg: _defineProperty({
      margin: theme.spacing(6.25, 0, 6),
      alignSelf: "center"
    }, theme.breakpoints.up(Webviewer.mobile), {
      margin: "50px 1px 51px 0px"
    }),
    backToBtn: _defineProperty({
      width: "100%"
    }, theme.breakpoints.up(Webviewer.mobile), {
      width: "192px",
      marginRight: theme.spacing(2)
    }),
    backBtn: _defineProperty({
      marginTop: theme.spacing(2),
      width: "100%"
    }, theme.breakpoints.up(Webviewer.mobile), {
      textTransform: "none",
      marginTop: 0
    }),
    numberIndder: _defineProperty({
      height: "20px",
      paddingTop: "3px"
    }, theme.breakpoints.up(Webviewer.mobile), {
      height: "20px",
      paddingTop: "3px"
    }),
    numberRound: _defineProperty({
      color: "#fff",
      borderRadius: "50px",
      backgroundColor: "".concat(_pittaModules.LightColors.primary["8"]),
      width: "20px",
      minWidth: "20px",
      height: "20px",
      fontSize: "11px",
      textAlign: "center",
      marginRight: "8px"
    }, theme.breakpoints.up(Webviewer.mobile), {
      color: "#fff",
      borderRadius: "50px",
      backgroundColor: "".concat(_pittaModules.LightColors.primary["8"]),
      width: "20px",
      minWidth: "20px",
      height: "20px",
      fontSize: "11px",
      textAlign: "center",
      marginRight: "8px"
    }),
    divFlex: _defineProperty({
      display: "flex"
    }, theme.breakpoints.up(Webviewer.mobile), {}),
    spanDiv: _defineProperty({
      display: "grid",
      minWidth: "0"
    }, theme.breakpoints.up(Webviewer.mobile), {}),
    spanSize: _defineProperty({
      marginBottom: theme.spacing(0.5)
    }, theme.breakpoints.up(Webviewer.mobile), {}),
    QRCode: _defineProperty({
      display: "none"
    }, theme.breakpoints.up(Webviewer.mobile), {
      display: "inline"
    }),
    btnDiv: _defineProperty({
      display: "inline"
    }, theme.breakpoints.up(Webviewer.mobile), {
      display: "flex"
    }),
    divider: _defineProperty({
      height: 163,
      marginTop: 5
    }, theme.breakpoints.down(Webviewer.mobile), {
      display: "none"
    })
  };
});
var ConnectToCloud = function ConnectToCloud(props) {
  var classes = useStyle();
  var LOnClick = props.LOnClick,
    ROnClick = props.ROnClick,
    LButton = props.LButton,
    RButton = props.RButton,
    heading = props.heading,
    firstTitle = props.firstTitle,
    secondTitle = props.secondTitle,
    firstContent = props.firstContent,
    secondContent = props.secondContent,
    bodyClassName = props.bodyClassName,
    mobile = props.mobile,
    headerCSS = props.headerCSS,
    firstCSS = props.firstCSS,
    secondCSS = props.secondCSS,
    appCSS = props.appCSS,
    imgCSS = props.imgCSS,
    btnCSS = props.btnCSS,
    appStoreCSS = props.appStoreCSS;
  return /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.body, bodyClassName)
  }, /*#__PURE__*/_react.default.createElement("div", null, heading ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.textTitle, headerCSS)
  }, /*#__PURE__*/_react.default.createElement(_.Typography, {
    category: "Default",
    variant: mobile ? "H2" : "H1"
  }, heading)) : "", firstTitle ? /*#__PURE__*/_react.default.createElement(_core.Box, {
    className: (0, _clsx.default)(classes.divFlex, firstCSS)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.numberRound
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.numberIndder
  }, "1")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.spanDiv
  }, /*#__PURE__*/_react.default.createElement(_.Typography, {
    category: "Default",
    variant: "Body",
    className: classes.spanSize
  }, firstTitle), firstContent ? /*#__PURE__*/_react.default.createElement(_.Typography, {
    style: {
      color: _pittaModules.LightColors.primary["3"]
    },
    category: "Default",
    variant: "Small",
    dangerouslySetInnerHTML: {
      __html: firstContent
    }
  }) : "")) : ""), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.qrCodeDiv, appCSS)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.appStoreDiv, classes.compareCheckDiv, appStoreCSS)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.appsDiv
  }, !mobile ? /*#__PURE__*/_react.default.createElement("img", {
    srcSet: "/images/iOSQRCode.png",
    alt: "IOSQRCode",
    className: classes.QRCode
  }) : "", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://apps.apple.com/kr/app/blackvue/id1049209637",
    className: classes.appAnchor,
    target: "_blank",
    rel: "noreferrer",
    style: {
      justifyContent: "center"
    }
  }, /*#__PURE__*/_react.default.createElement("img", {
    srcSet: "/images/appstore-badge.png 1x, /images/appstore-badge@2x.png 2x",
    alt: "firstStoreLink"
  }))), !mobile && /*#__PURE__*/_react.default.createElement(_core.Divider, {
    orientation: "vertical",
    className: classes.divider
  }), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.androidDiv
  }, !mobile ? /*#__PURE__*/_react.default.createElement("img", {
    srcSet: "/images/AndroidQRCode.png",
    alt: "AndroidQRCode",
    className: classes.QRCode
  }) : "", /*#__PURE__*/_react.default.createElement("a", {
    href: "https://play.google.com/store/apps/details?id=comb.blackvuec",
    className: classes.appAnchor,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react.default.createElement("img", {
    srcSet: "/images/google-play-badge.png 1x, /images/google-play-badge@2x.png 2x",
    alt: "secondStoreLink"
  }))))), /*#__PURE__*/_react.default.createElement("div", null, secondTitle ? /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.divFlex, secondCSS)
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.numberRound
  }, /*#__PURE__*/_react.default.createElement("div", {
    className: classes.numberIndder
  }, "2")), /*#__PURE__*/_react.default.createElement("div", {
    className: classes.spanDiv
  }, /*#__PURE__*/_react.default.createElement(_.Typography, {
    category: "Default",
    variant: "Body",
    className: classes.spanSize,
    dangerouslySetInnerHTML: {
      __html: secondTitle
    }
  }), secondContent ? /*#__PURE__*/_react.default.createElement(_.Typography, {
    style: {
      color: _pittaModules.LightColors.primary["3"]
    },
    category: "Default",
    variant: "Small",
    dangerouslySetInnerHTML: {
      __html: secondContent
    }
  }) : "")) : ""), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.cloudImg, imgCSS)
  }, /*#__PURE__*/_react.default.createElement("img", {
    srcSet: "/images/ConnectToCloud.png",
    alt: "connect to cloud"
  })), /*#__PURE__*/_react.default.createElement("div", {
    className: (0, _clsx.default)(classes.btnDiv, btnCSS)
  }, LButton ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_.Button, {
    variant: "contained",
    color: "primary",
    onClick: LOnClick,
    className: (0, _clsx.default)(classes.backToBtn)
  }, LButton)) : "", RButton ? /*#__PURE__*/_react.default.createElement("div", null, /*#__PURE__*/_react.default.createElement(_.Button, {
    variant: "outlined",
    color: "primary",
    className: (0, _clsx.default)(classes.backBtn),
    onClick: ROnClick
  }, RButton)) : ""));
};
exports.ConnectToCloud = ConnectToCloud;